/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { LogoPartner } from '../LogoPartner';
import './style.css';

export const LogosPartnersGroup = ({
    breakpoint,
    color,
    className,
    logoPartnerBundesministerium = '/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg',
}) => {
    return (
        <div
            className={`logos-partners-group color-5-${color} breakpoint-0-${breakpoint} ${className}`}
        >
            <LogoPartner
                className={`${
                    color === 'default' && breakpoint === 'mobile'
                        ? 'class-6'
                        : color === 'white' && breakpoint === 'mobile'
                          ? 'class-7'
                          : color === 'white' && breakpoint === 'desktop'
                            ? 'class-8'
                            : 'class-9'
                }`}
                color={color === 'white' ? 'white' : 'default'}
                partner="vector-shiftung"
                size={breakpoint === 'mobile' ? 'mobile' : 'desktop'}
            />
            {color === 'default' && breakpoint === 'desktop' && (
                <LogoPartner
                    className="logo-partner-instance"
                    color="default"
                    partner="uni-t-b"
                    size="desktop"
                />
            )}

            <LogoPartner
                className={`${
                    color === 'white' && breakpoint === 'mobile'
                        ? 'class-10'
                        : color === 'white' && breakpoint === 'desktop'
                          ? 'class-11'
                          : color === 'default' && breakpoint === 'desktop'
                            ? 'class-12'
                            : 'class-13'
                }`}
                color={color === 'white' ? 'white' : 'default'}
                lernenDigital={
                    color === 'default'
                        ? '/img/lernen-digital-transferstelle-anthrazit-rgb-1.png'
                        : undefined
                }
                partner="lernen-digital"
                size={breakpoint === 'desktop' ? 'desktop' : 'mobile'}
            />
        </div>
    );
};

LogosPartnersGroup.propTypes = {
    breakpoint: PropTypes.oneOf(['desktop', 'mobile']),
    color: PropTypes.oneOf(['white', 'default']),
    logoPartnerBundesministerium: PropTypes.string,
};
